import React, { useState, useEffect } from 'react';
import './App.css';
import { Toaster } from './components/ui/sonner';
import Navigation from './components/Navigation';
import HeroSection, { SubtleRain } from './components/HeroSection';
import CrisisStats from './components/CrisisStats';
import MissionSection from './components/MissionSection';
import TechnologySection from './components/TechnologySection';
import DonationForm from './components/DonationForm';
import Footer from './components/Footer';

function App() {
  const [language, setLanguage] = useState('en');

  useEffect(() => {
    const savedLang = localStorage.getItem('hidrolife-lang');
    if (savedLang) setLanguage(savedLang);
  }, []);

  const handleLanguageChange = (lang) => {
    setLanguage(lang);
    localStorage.setItem('hidrolife-lang', lang);
  };

  return (
    <div className="App" data-testid="hidrolife-app">
      {/* Toast */}
      <Toaster 
        position="top-center"
        toastOptions={{
          style: {
            background: '#0F1E30',
            border: '1px solid rgba(201, 169, 107, 0.3)',
            color: '#fff',
          },
        }}
      />

      {/* Subtle Rain - Global */}
      <SubtleRain />

      {/* Navigation */}
      <Navigation language={language} setLanguage={handleLanguageChange} />

      {/* Seamless sections - no cuts */}
      <main className="relative">
        <HeroSection language={language} />
        <CrisisStats language={language} />
        <MissionSection language={language} />
        <TechnologySection language={language} />
        <DonationForm language={language} />
      </main>

      <Footer language={language} />
    </div>
  );
}

export default App;
